import { ChevronDown, ChevronRight } from "lucide-react";
import { ReactNode } from "react";

interface ExternalStorageSectionCollapsibleProps {
  title: string;
  expanded: boolean;
  disabled?: boolean;
  onToggle: () => void;
  children?: ReactNode;
}

const ExternalStorageSectionCollapsible = ({
  title,
  expanded,
  disabled = false,
  onToggle,
  children
}: ExternalStorageSectionCollapsibleProps) => (
  <div className="tw-border tw-border-border tw-rounded-lg tw-overflow-hidden">
    <button
      type="button"
      onClick={() => !disabled && onToggle()}
      className={`tw-flex tw-items-center tw-justify-between tw-w-full tw-px-4 tw-py-3 tw-bg-secondary/40 tw-transition-colors tw-text-left ${
        disabled ? "tw-opacity-50 tw-cursor-not-allowed" : "hover:tw-bg-secondary/60"
      }`}
    >
      <div className="tw-flex tw-items-center tw-gap-2 tw-min-w-0">
        {expanded ? (
          <ChevronDown className="tw-h-4 tw-w-4 tw-text-muted-foreground tw-shrink-0" />
        ) : (
          <ChevronRight className="tw-h-4 tw-w-4 tw-text-muted-foreground tw-shrink-0" />
        )}
        <span className="tw-text-sm tw-font-semibold tw-text-foreground">{title}</span>
      </div>
    </button>
    {expanded && children && (
      <div
        className={`tw-px-4 tw-py-4 tw-space-y-3 ${
          disabled ? "tw-opacity-50 tw-pointer-events-none" : ""
        }`}
      >
        {children}
      </div>
    )}
  </div>
);

export default ExternalStorageSectionCollapsible;
